import MarkdownField from '@/modules/document/_component/fields/MarkdownField.vue';
import MarkdownValue from '@/modules/document/_component/values/MarkdownValue.vue';

const types = [
    {
        text: 'Page break',
        value: 'pagebreak',
    },
    {
        text: 'Rich text',
        value: 'markdown',
        component: MarkdownField,
        valueComponent: MarkdownValue,
    },
];

export default types;
